<!--
 * @Author: zuishuanicx 1342142818@qq.com
 * @Date: 2022-03-16 14:48:52
 * @LastEditors: zuishuanicx 1342142818@qq.com
 * @LastEditTime: 2023-05-09 15:09:28
 * @FilePath: \dzCloud\src\projects\tiktok\App.vue
 * @Description: 这是默认设置,请设置`customMade`, 打开koroFileHeader查看配置 进行设置: https://github.com/OBKoro1/koro1FileHeader/wiki/%E9%85%8D%E7%BD%AE
-->
<template>
    <router-view :userInfo="userInfo" />
</template>

<script>
import store from './store';
import sentryConfig from './plugins/sentryConfig';

export default {
    components: {},
    data() {
        return {
            userInfo: {},
            queryData: {
                code: '',
            },
        };
    },
    created() {
        this.$ajax
            .get('/api/tiktok/User/Get')
            .then((res) => {
                if (res.code === 200) {
                    // 设置埋点用户信息
                    localStorage.setItem(
                        'dzhmUserinfo',
                        JSON.stringify({
                            userId: res.result.uid, // 用户ID
                            userName: res.result.name, // 用户名称
                            userTel: res.result.mobilePhone, // 用户的电话号码
                            userTime: res.result.createTime, // 用户创建时间
                            serverEndTime: res.result.serEndTime,
                            // version: res.result.versionNo === '试用版' ? 0 : 1, // 版本信息
                            version: res.result.version, // 版本信息
                            versionNo: res.result.versionNo, //版本
                            memberId: res.result.uid, //用于多店铺
                        })
                    );

                    this.userInfo = res.result;
                    localStorage.setItem('userInfo', JSON.stringify(res.result));
                    dazeTask.login(res.result.uid);
                    sentryConfig.refresh(res.result.uid);

                    store.state.userInfo = res.result;
                } else if (res.code === 5000) {
                    this.$message.error(res.msg);
                    setTimeout(() => {
                        !process.env.NODE_ENV === 'development' &&
                            (window.location.href = 'http://occ.fjdaze.com/auth/login?appkey=6840999917110199815');
                    }, 2000);
                } else {
                    this.$message.error({
                        type: 'error',
                        message: '授权失效，正在重新授权',
                    });
                    setTimeout(() => {
                        !process.env.NODE_ENV === 'development' &&
                            (window.location.href = 'http://occ.fjdaze.com/auth/login?appkey=6840999917110199815');
                    }, 2000);
                }
            })
            .catch(() => {
                this.$message.error({
                    type: 'erorr',
                    message: '授权失效，正在重新授权',
                });
                setTimeout(() => {
                    !process.env.NODE_ENV === 'development' &&
                        (window.location.href = 'http://occ.fjdaze.com/auth/login?appkey=6840999917110199815');
                }, 2000);
            });
    },
};
</script>

<style lang="scss" scoped></style>
